// extracted by mini-css-extract-plugin
export default {"panel":"SalesGoalsPanel_panel__rSPQD","form":"SalesGoalsPanel_form__Gqas-","field":"SalesGoalsPanel_field__41EO1","label":"SalesGoalsPanel_label__JbXWx"};